var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stepForm',{attrs:{"user":_vm.user,"request":_vm.request,"request-buttons":_vm.requestButtons,"btn-position":_vm.btnPosition},on:{"input":function($event){return _vm.$emit('input')}}}),(_vm.showHistory)?_c('div',{staticClass:"mt-3"},[_c('history-days-off')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }